module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_6.35f924de.pdf";